import React, { useEffect, useRef, useState, useMemo } from 'react'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './create_solution.css'
import { getSolutionMappedTo } from '../../../functions/get_solution_to';
import { getSolutionFromProblem } from '../../../functions/solution';
import { formatProblemDisplay } from '../../../global/http_enum';

// Helper function to find the correct problem for an event
const findProblemForEvent = (project, selectedEvent) => {
    if (!project?.problem || !selectedEvent?.id) {
        return project?.problem?.find(obj => obj.domain === selectedEvent?.domain) || null;
    }

    // Try to get problem ID from localStorage
    try {
        const getStorageKey = () => `eventProblems_${project?.id || 'default'}`;
        const stored = localStorage.getItem(getStorageKey());
        if (stored) {
            const eventProblemMap = new Map(JSON.parse(stored));
            const problemId = eventProblemMap.get(selectedEvent.id);

            // If we have a problem ID, find by ID first
            if (problemId) {
                const problemById = project.problem.find(obj => obj.id === problemId);
                if (problemById) {
                    return problemById;
                }
            }
        }
    } catch (error) {
        console.error('Failed to load event problem map:', error);
    }

    // Fallback to domain matching
    return project.problem.find(obj => obj.domain === selectedEvent.domain) || null;
};

export default function CreateSolutionWidget({ project, selectedEvent, SetSolutionImplimantation }) {
    const [solutiionMappedTo, SetSolutionMappedTo] = useState([]);
    const [solutionImages, setSolutionImages] = useState([]);
    const solutionImagesSliderRef = useRef();
    const theoryObject = useRef(findProblemForEvent(project, selectedEvent));

    // Get the domain type from event - check both eventType and domain properties
    const domain = useMemo(() => selectedEvent?.eventType || selectedEvent?.domain || 'Theory', [selectedEvent?.eventType, selectedEvent?.domain]);

    useEffect(() => {
        theoryObject.current = findProblemForEvent(project, selectedEvent);
        if (theoryObject.current?.problem_mapped_to) {
            SetSolutionMappedTo(getSolutionMappedTo(theoryObject.current.problem_mapped_to, selectedEvent.domain))
            
            // Get solution images from problem mapped to
            const images = getSolutionFromProblem(theoryObject.current.problem_mapped_to, selectedEvent.domain);
            setSolutionImages(images);
        } else {
            setSolutionImages([]);
        }
    }, [project, selectedEvent, domain])

    const settingsSlick = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    return (
        <div id='solution-view'>
            <div className='solution-view-container'>
                <div className='solution-details-panel'>
                    <div className='detail-field'>
                        <label className='detail-label'>Event Name</label>
                        <div className='detail-value'>{selectedEvent.name || ''}</div>
                    </div>

                    <div className='detail-field'>
                        <label className='detail-label'>Negative Function Executed</label>
                        <div className='detail-value negative'>{selectedEvent.negative_function_exluded || ''}</div>
                    </div>

                    <div className='detail-field'>
                        <label className='detail-label'>Problem Identified from Event</label>
                        <div className='detail-value negative'>{formatProblemDisplay(selectedEvent.problem_identifyed_from_event) || ''}</div>
                    </div>

                    <div className='detail-field'>
                        <label className='detail-label'>Principle Deficiency</label>
                        <div className='detail-value'>
                            {theoryObject.current?.pricipal_defeciency?.join(', ') || ''}
                        </div>
                    </div>

                    <div className='detail-field'>
                        <label className='detail-label'>Problem Mapped to</label>
                        <div className='detail-value'>
                            {theoryObject.current?.problem_mapped_to?.join(', ') || ''}
                        </div>
                    </div>

                    <div className='detail-field'>
                        <label className='detail-label'>Solution Mapped</label>
                        <div className='detail-value'>
                            {solutiionMappedTo.join(', ') || ''}
                        </div>
                    </div>
                </div>

                {solutionImages.length > 0 && (
                    <div className='solution-images-panel'>
                        <div className="images">
                            <h1 className='title'>Solution Mapped To</h1>
                            <Slider ref={solutionImagesSliderRef} className='carasoul-box' {...settingsSlick}>
                                {solutionImages.map((image, index) => (
                                    <div key={index} className="carousel-slide">
                                        <img alt={`Solution Mapped To ${index + 1}`} src={image} className="solution-image" />
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}
